
<div class="message" [class.system]="role() == 'system'" [class.user]="role() == 'user'" [class.assistant]="role() == 'assistant'">
  <div class="message-header">
    @if (sender()) {
      <div>{{ sender() }}</div>
    }
    @if (sentDate()) {
      <div>{{ sentDate()?.toLocaleString() }}</div>
    }
  </div>
  @if (messageContent()) {
    <div class="message-content">{{ messageContent() }}</div>
  }
  <div class="message-body">
    <ng-content></ng-content>
  </div>
</div>
